import { render } from "./return-button.vue?vue&type=template&id=84ba97ac&scoped=true"
import script from "./return-button.vue?vue&type=script&lang=js"
export * from "./return-button.vue?vue&type=script&lang=js"

import "./return-button.vue?vue&type=style&index=0&id=84ba97ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ba97ac"]])

export default __exports__